import "./publicationCard.css";

export default function PublicationCard({
  title,
  conference,
  countryFlag,
  countryName = "",
  image,
  imageAlt = "",
  abstract,
  paperUrl,
  codeUrl,
  readMoreUrl,
  layout = "wide",
}) {
  return (
    <article className={`publication-card publication-card--${layout}`}>
      <div className="publication-card-content">
        <div className="publication-card-text">
          <div className="publication-title-row">
            <h3>{title}</h3>

            {countryFlag && (
              <span className="publication-country-flag">
                <img
                  src={countryFlag}
                  alt={countryName ? `${countryName} flag` : "Conference country flag"}
                />
              </span>
            )}
          </div>

          {conference && (
            <p className="publication-conference">{conference}</p>
          )}

          {abstract && (
            <p className="publication-abstract">
              {abstract}
              {readMoreUrl && (
                <>
                  {" "}
                  <a href={readMoreUrl} target="_blank" rel="noreferrer">
                    ... read more
                  </a>
                </>
              )}
            </p>
          )}

          <div className="publication-buttons">
            {paperUrl && (
              <a
                href={paperUrl}
                target="_blank"
                rel="noreferrer"
                className="publication-button"
              >
                Paper
                <span className="publication-button-icon">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M14 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V9L14 3Z"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 3V9H20"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </a>
            )}

            {codeUrl && (
              <a
                href={codeUrl}
                target="_blank"
                rel="noreferrer"
                className="publication-button"
              >
                Code
                <span className="publication-button-icon">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 18L22 12L16 6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 6L2 12L8 18"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </a>
            )}
          </div>
        </div>
      </div>

      {image && (
        <div className="publication-card-image">
          <img src={image} alt={imageAlt} />
        </div>
      )}
    </article>
  );
}